import React from "react";
import logo from "../../../../assets/Images/logo-icon.png";
import logoBig from "../../../../assets/Images/au-logo-long.png";
import "./logo.css";
import { Link } from "react-router-dom";

export default function Logo({ sidebarOpen }) {

    return (
        <Link draggable={false} to={"/"} className="logo" style={{ textDecoration: "none" }}>
            {sidebarOpen ? <img draggable={false} src={logoBig} alt="AutomMate Logo" style={{ width: "75%" }} /> :
                <img src={logo} alt="AutomMate Logo" />}
            {/* <ChevronLeft className={classes.svgIcon} /> */}
        </Link>
    )
}
